export const en = {
  nav: {
    transactions: 'Transactions',
    balance: 'Balance',
    cards: 'Cards / Accounts',
    invoices: 'Pay by Link',
    bankTransfers: 'Bank Transfers',
    apiManagement: 'API Management',
    sandboxTools: 'Sandbox tools',
    callbacks: 'Callbacks',
    requestLog: 'Request Log',
    testCards: 'Test Cards',
    signatureTool: 'Signature Tool',
    menu: 'Menu',
  },
  common: {
    loading: 'Loading…',
    apiUnreachable: 'Could not reach the sandbox API.',
    apiUnreachableHint: 'Check that the API is running on port 8181.',
    noData: 'No data was found for the selected period.',
    total: 'Total',
    copy: 'Copy',
    copied: 'Copied',
    show: 'Show',
    hide: 'Hide',
    inspect: 'Inspect',
    notSet: 'not set',
    expandRow: 'Expand row',
    collapseRow: 'Collapse row',
    edit: 'Edit',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    apiReference: 'API reference',
  },
  transactions: {
    title: 'Transactions',
    empty: 'No transactions yet. Create one with POST /api/1/request.',
    transaction: 'Transaction',
    orderId: 'Order ID',
    status: 'Status',
    sum: 'Sum',
    bankCode: 'Bank code',
    card: 'Card',
    rrn: 'RRN',
    endpoint: 'Endpoint',
    description: 'Description',
    traceId: 'Trace ID',
    date: 'Date',
  },
  callbacks: {
    title: 'Callbacks',
    empty: 'No callbacks delivered yet.',
    emptyHint: 'Set result_url on API Management, then complete a payment at checkout.',
    attempt: 'attempt',
    noResponse: 'no response',
    decodedPayload: 'Decoded payload',
    rawData: 'data (base64)',
    signature: 'signature',
    yourResponse: 'Your response',
    error: 'Error',
  },
  requestLog: {
    title: 'Request Log',
    empty: 'No API requests recorded yet.',
    method: 'Method',
    path: 'Path',
    status: 'Status',
    signature: 'Signature',
    valid: 'valid',
    invalid: 'invalid',
    time: 'Time',
    request: 'Request',
    response: 'Response',
  },
  apiManagement: {
    title: 'API Management',
    publicKey: 'Public key',
    privateKey: 'Private key',
    websiteAddress: 'Website address',
    successLink: 'Success link',
    failedLink: 'Failed link',
    resultLink: 'Link to send the result',
    connectionOptions: 'Connection options',
    accessEnabled: 'API access is enabled.',
    rotateKey: 'Issue a new private key',
    rotateNote: 'Existing signatures stop verifying, exactly as in production.',
    pointHere: 'Point your integration here',
    pointHereBody:
      'Swap the base URL and nothing else changes. Every path under /api/1/ matches production.',
    callbackNote:
      'Callbacks are sent from inside the container. Point result_url at http://host.docker.internal:PORT rather than localhost.',
  },
  testCards: {
    title: 'Test Cards',
    intro: 'epoint publishes no test cards, so the sandbox defines its own.',
    outro: 'Reading the number tells you what will happen.',
    cardNumber: 'Card number',
    bankCode: 'Bank code',
    outcome: 'Outcome',
    result: 'Result',
    approved: 'approved',
    declined: 'declined',
  },
  signature: {
    title: 'Signature Tool',
    intro: 'epoint signs requests with',
    introAfter:
      'The SHA-1 digest must be the raw 20 bytes, not the hex string. Paste a failing pair below and this will name the exact mistake.',
    verifyTitle: 'Verify a signature',
    buildTitle: 'Build a signed request',
    privateKey: 'Private key',
    data: 'data (base64)',
    signature: 'signature',
    check: 'Check',
    sign: 'Sign',
    payload: 'Payload (JSON)',
    matches: 'Signature matches.',
    noMatch: 'Signature does not match.',
    invalidJson: 'Payload is not valid JSON.',
    formula: 'Formula',
    hashedString: 'Hashed string',
    expected: 'Expected signature',
    decoded: 'Decoded payload',
    readyToRun: 'Ready to run',
  },
  planned: {
    balanceTitle: 'Balance',
    balanceSummary: 'Balance ledger is not wired up yet.',
    cardsTitle: 'Cards / Accounts',
    cardsSummary: 'No cards registered yet.',
    invoicesTitle: 'Pay by Link',
    invoicesSummary: 'Invoices are not implemented yet.',
    backedBy: 'Backed by',
    notImplemented: 'which are not implemented yet.',
  },
  balance: {
    title: 'Balance',
    empty: 'No balance movement yet.',
    emptyHint: 'Complete a payment at checkout and the ledger fills in.',
    current: 'Current balance',
    entry: 'Entry',
    kind: 'Type',
    amount: 'Amount',
    runningTotal: 'Balance after',
    description: 'Description',
    date: 'Date',
    kinds: {
      payment: 'Payment',
      commission: 'Commission',
      split_in: 'Split received',
      split_out: 'Split sent',
      refund: 'Refund',
      payout: 'Payout',
      reversal: 'Reversal',
    },
  },
  cards: {
    title: 'Cards / Accounts',
    empty: 'No cards registered yet.',
    emptyHint: 'Call /api/1/card-registration and complete the redirect.',
    cardId: 'Card ID',
    mask: 'Card number',
    holder: 'Cardholder',
    expiry: 'Expires',
    status: 'Status',
    type: 'Type',
    payout: 'Payout card',
    payment: 'Payment card',
    description: 'Description',
    added: 'Added',
  },
  invoices: {
    title: 'Pay by Link',
    empty: 'No invoices yet.',
    emptyHint: 'Create one with /api/1/invoices/create.',
    id: '#',
    total: 'Sum',
    status: 'Status',
    recipient: 'Name',
    description: 'Description',
    contact: 'Contact',
    period: 'Period',
    template: 'Template',
    created: 'Date',
    sent: 'Sent messages',
    sentEmpty: 'Nothing sent yet.',
    channel: 'Channel',
    recipientLabel: 'Recipient',
    subject: 'Subject',
    body: 'Message',
    statuses: {
      waiting_for_payment: 'Waiting for payment',
      paid: 'Paid',
      canceled: 'Canceled',
    },
  },
  b2b: {
    title: 'Bank Transfers',
    empty: 'No bank transfers yet.',
    emptyHint: 'Create one with POST /api/1/b2b/payment.',
    orderId: 'Order ID',
    status: 'Status',
    amount: 'Amount',
    payee: 'Recipient',
    iban: 'IBAN',
    bankCode: 'Bank code',
    webhookSent: 'Webhook',
    bulkId: 'Bulk ID',
    created: 'Date',
    advance: 'Advance',
    yes: 'sent',
    no: 'not sent',
  },
  features: {
    title: 'Features',
    intro:
      'epoint grants these per merchant on request. They are off here for the same reason, so an integration meets the same refusal it would in production.',
    amex_enabled: 'AMEX payments',
    token_payments_enabled: 'Apple Pay and Google Pay',
    installments_enabled: 'Installment payments',
    wallets_enabled: 'Wallet payments',
    b2b_enabled: 'B2B bank transfers',
  },
  accounts: {
    title: 'Accounts',
    intro:
      'Production gives you one merchant account. The sandbox lets you hold several so split payments have a real partner to reference.',
    newName: 'Account name',
    create: 'Create account',
    select: 'Select',
    remove: 'Delete',
    active: 'active',
  },
  login: {
    title: 'Sign in',
    subtitle: 'This sandbox is protected by an admin password.',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signingIn: 'Signing in…',
    failed: 'Could not sign in. Try again.',
    hint: 'Credentials are set with EPOINT_ADMIN_EMAIL and EPOINT_ADMIN_PASSWORD.',
    signOut: 'Sign out',
    openAccess: 'No auth',
    openAccessHint:
      'Anyone who can reach this sandbox can read your keys. Set EPOINT_ADMIN_EMAIL and EPOINT_ADMIN_PASSWORD to require a login.',
  },
  footer: {
    sandbox: 'Sandbox',
    reference: 'Reference',
    baseUrl: 'Base URL',
    blurb:
      'A local sandbox for developers integrating with the epoint.az payment gateway. No real payments are processed here.',
    callbackNote: 'Callbacks reach your machine at host.docker.internal, not localhost.',
    openapi: 'OpenAPI schema',
    developerPortal: 'Epoint developer portal',
    legal: 'Epoint Sandbox. Not affiliated with Epoint. For local development only.',
  },
} as const

/** Widens `as const` literals so values may differ but keys may not. */
type Widen<T> = { [K in keyof T]: T[K] extends string ? string : Widen<T[K]> }

export type Dictionary = Widen<typeof en>
